import { Api } from './Api';

const  ENPOINTS = {
    TypePiece: 'type-pieces',
};

const getAll = signal => {
    return Api.get(`user/${ENPOINTS.TypePiece}`, signal)
}

const getById = (id, signal) => {
    return Api.get(`${ENPOINTS.TypePiece}/${id}`, signal);
}

const create = (payload, signal) => {
    return Api.post(ENPOINTS.TypePiece, payload, signal)
}

const update = (id, payload, signal) => {
    return Api.put(`${ENPOINTS.TypePiece}/${id}`, payload, signal)
}
const destroy = (id, signal) => {
    return Api.erase(`${ENPOINTS.TypePiece}/${id}`, signal)
}

export const TypePieceService = {
    getAll,
    getById,
    create,
    update,
    destroy
}